/**
 * 导航栏相关的reducer
 */
import { combineReducers } from 'redux'
import {
  SET_CUR_ONENODE,
  SET_CUR_TWONODE1,
  SET_CUR_TWONODE2,
  SET_CUR_TWONODE3,
  SET_CUR_TWONODE4,
  SET_CUR_TWONODE5,
  SET_CUR_TWONODE6,
  SET_CUR_TWONODE7,
  SET_PRE_TWONODE1,
  SET_PRE_TWONODE2,
  SET_PRE_TWONODE3,
  SET_PRE_TWONODE4,
  SET_PRE_TWONODE5,
  SET_PRE_TWONODE6,
  SET_PRE_TWONODE7,
  SET_CUR_THREENODE,
  SET_PRE_THREENODE,
  SET_CURNAME,
  SET_INITTREEONE,
  SET_INITTREETWO,
  SET_ONLINEUSERCOUNT
} from '../actions/navbar_action'

import * as ACTIONS from '../actions/navbar_action'

const initialState = {
  curOneNode: ""
};
function initTreeOne(state = "", action) {
  switch (action.type) {
    case SET_INITTREEONE:
      return action.curNode;
    default:
      return state
  }
}
function initTreeTwo(state = "", action) {
  switch (action.type) {
    case SET_INITTREETWO:
      return action.curNode;
    default:
      return state
  }
}
// function curOneNode(state = initialState, action) {
//   switch (action.type) {
//     case SET_CUR_ONENODE:
//       return Object.assign({},state,{
//         curOneNode: action.curNode
//       });
//     default:
//       return state
//   }
// }

function curName(state = "", action) {
  switch (action.type) {
    case SET_CURNAME:
      return action.curName;
    default:
      return state
  }
}

function curOneNode(state = "", action) {
  switch (action.type) {
    case SET_CUR_ONENODE:
      return action.curNode;
    default:
      return state
  }
}

function curThreeNode(state = "", action) {
  switch (action.type) {
    case SET_CUR_THREENODE:
      return action.curNode;
    default:
      return state
  }
}

function preThreeNode(state = "", action) {
  switch (action.type) {
    case SET_PRE_THREENODE:
      return action.curNode;
    default:
      return state
  }
}

function curTwoNode(state = "", action) {
  switch (action.type) {
    case SET_CUR_TWONODE1:
      return Object.assign({},state,{
              indexMenu: action.curNode
            });
    case SET_CUR_TWONODE2:
      return Object.assign({},state,{
              resourceMenu: action.curNode
            });
    case SET_CUR_TWONODE3:
      return Object.assign({},state,{
              assetMenu: action.curNode
            });
    case SET_CUR_TWONODE4:
      return Object.assign({},state,{
              mapMenu: action.curNode
            });
    case SET_CUR_TWONODE5:
      return Object.assign({},state,{
              workOrderMenu: action.curNode
            });
    case SET_CUR_TWONODE6:
      return Object.assign({},state,{
              reportMenu: action.curNode
            });
    case SET_CUR_TWONODE7:
      return Object.assign({},state,{
              systemMenu: action.curNode
            });
    default:
      return state
  }
}

function preTwoNode(state = "", action) {
  switch (action.type) {
    case SET_PRE_TWONODE1:
      return Object.assign({},state,{
              indexMenu: action.curNode
            });
    case SET_PRE_TWONODE2:
      return Object.assign({},state,{
              resourceMenu: action.curNode
            });
    case SET_PRE_TWONODE3:
      return Object.assign({},state,{
              assetMenu: action.curNode
            });
    case SET_PRE_TWONODE4:
      return Object.assign({},state,{
              mapMenu: action.curNode
            });
    case SET_PRE_TWONODE5:
      return Object.assign({},state,{
              workOrderMenu: action.curNode
            });
    case SET_PRE_TWONODE6:
      return Object.assign({},state,{
              reportMenu: action.curNode
            });
    case SET_PRE_TWONODE7:
      return Object.assign({},state,{
              systemMenu: action.curNode
            });
    default:
      return state
  }
}

function monitorCount(state = 0, action) {//监测器总数
    switch (action.type) {
        case ACTIONS.SET_MONITORCOUNT:
            return action.monitorCount
        default:
            return state
    }
}

function onlineUserCount(state = 1, action) { //在线用户数。新后端无 ws 推送，初始按当前登录用户计 1
  switch (action.type) {
    case ACTIONS.SET_ONLINEUSERCOUNT:
      return action.onlineUserCount;
    default:
      return state;
  }
}

const navbarReducer = combineReducers({
  curOneNode,
  curTwoNode,
  preTwoNode,
  curThreeNode,
  preThreeNode,
  curName,
  initTreeOne,
  initTreeTwo,
  monitorCount,
  onlineUserCount
})

export default navbarReducer
